/**
 * rootReducer.ts
 * Copyright (c) 2023 James Ugbanu.
 * Licensed under the MIT License.
 */


import {combineReducers} from "@reduxjs/toolkit";
import authReducer from "../store/authSlice"

const rootReducer = combineReducers({
    auth: authReducer
})

export default rootReducer;
